import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IJob } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'customrecruitmentquestions'


const filter = (axios: IFactoryFunctionRequest<Array<Pick<IJob, '_id' | 'display'>>, undefined>) => (options = {}) => {
  const route = options.firmId ? `filter/external/:firmId` : 'filter'
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${route}`,
    query: options,
  })
}


const createOne = (axios: IFactoryFunctionRequest<any, undefined>) => (question: any) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/create`,
    data: question,
  })
}

const updateOne = (axios: IFactoryFunctionRequest<any, undefined>) => (question: any) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/update/${question?._id}`,
    data: question,
  })
}

const deleteOne = (axios: IFactoryFunctionRequest<any, undefined>) => (question: any) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${question}`,
  })
}


export default (axios: AxiosInstance) => ({
  filter: filter(useAxios(axios)),
  createOne: createOne(useAxios(axios)),
  updateOne: updateOne(useAxios(axios)),
  deleteOne: deleteOne(useAxios(axios)),
})
